import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Headline from 'components/Headline/Headline';
import Loader from 'components/Loader/Loader';
import ActivateToggle from 'components/ActivateToggle/ActivateToggle';
import { KeyValueDTO } from 'generated/models/KeyValueDTO';
import { KeyValueStoreService } from 'generated/services/KeyValueStoreService';

const ToggleShowOrders = () => {
  // TODO take from kvstore Redux
  const [showOrders, setShowOrders] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['translation', 'settings']);

  const getValue = async (): Promise<boolean> => {
    const keyValueDto = await KeyValueStoreService.getKeyValueStoreItem(
      KeyValueDTO.key.CREATOR_SHOW_ORDERS,
    );

    return keyValueDto.value === 'true';
  };

  const setValue = async (): Promise<void> => {
    setLoading(true);

    const keyValueDto = await KeyValueStoreService.setKeyValueStoreItem({
      key: KeyValueDTO.key.CREATOR_SHOW_ORDERS,
      value: showOrders ? 'false' : 'true',
    });

    setLoading(false);

    setShowOrders(keyValueDto.value === 'true');
  };

  useEffect(() => {
    getValue().then((_showOrders) => setShowOrders(_showOrders));
  }, []);

  return (
    <div>
      <Headline className="settings__headline" headingLevel="h2" size={2}>
        {t('settings:toggle-show-orders.headline')}
      </Headline>

      <p className="settings__block page__form-desc">
        {t('settings:toggle-show-orders.description')}
      </p>

      {showOrders === undefined ? (
        <Loader />
      ) : (
        <div>
          <label id="statistic-orders-toggle-desc" className="input__label">
            {t('edit')}
          </label>

          <ActivateToggle
            active={showOrders}
            onToggle={setValue}
            ariaDescribedBy="#statistic-orders-toggle-desc"
            loading={loading}
            activeIcon="eye"
            inactiveIcon="eye-off"
          />
        </div>
      )}
    </div>
  );
};

export default ToggleShowOrders;
